import {Component, TemplateRef} from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import {ToastService} from "../../services/toaster.service";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-toasts',
  templateUrl: './toasts.component.html',
  standalone: true,
  imports: [CommonModule, NgbToastModule],
  styles: [`
    :host {
      position: fixed;
      top: 0;
      right: 0;
      margin: 0.5em;
      z-index: 1200;
    }`
  ]
})
export class ToastsComponent {
  constructor(public toastService: ToastService) {}

  isTemplate(toast: any): boolean {
    return toast.textOrTpl instanceof TemplateRef;
  }
}
